import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const challengesShortTextViewer = {
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map